import icon_dashboard from "./apps-add.svg";

export const DepartmentProfileNavIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="17"
      height="17"
    >
      <g id="_01_align_center" data-name="01 align center">
        <path
          d="M0,3v8H11V0H3A3,3,0,0,0,0,3ZM9,9H2V3A1,1,0,0,1,3,2H9Z"
          fill="currentColor"
        />
        <path
          d="M0,21a3,3,0,0,0,3,3h8V13H0Zm2-6H9v7H3a1,1,0,0,1-1-1Z"
          fill="currentColor"
        />
        <path
          d="M13,13V24h8a3,3,0,0,0,3-3V13Zm9,8a1,1,0,0,1-1,1H15V15h7Z"
          fill="currentColor"
        />
        <polygon
          points="17 11 19 11 19 7 23 7 23 5 19 5 19 1 17 1 17 5 13 5 13 7 17 7 17 11"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const DashboardNavIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="17"
      height="17"
    >
      <g id="_01_align_center" data-name="01 align center">
        <path
          fill="currentColor"
          d="M13.338.833a2,2,0,0,0-2.676,0L0,10.429v10.4a3.2,3.2,0,0,0,3.2,3.2H20.8a3.2,3.2,0,0,0,3.2-3.2v-10.4ZM15,22.026H9V17a3,3,0,0,1,6,0Zm7-1.2a1.2,1.2,0,0,1-1.2,1.2H17V17A5,5,0,0,0,7,17v5.026H3.2a1.2,1.2,0,0,1-1.2-1.2V11.319l10-9,10,9Z"
        />
      </g>
    </svg>
  );
};

export const AllAppointmentsNavIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      width="17"
      height="17"
    >
      <path
        fill="currentColor"
        d="M19,2h-1V1c0-.552-.447-1-1-1s-1,.448-1,1v1H8V1c0-.552-.447-1-1-1s-1,.448-1,1v1h-1C2.243,2,0,4.243,0,7v12c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V7c0-2.757-2.243-5-5-5ZM5,4h14c1.654,0,3,1.346,3,3v1H2v-1c0-1.654,1.346-3,3-3Zm14,18H5c-1.654,0-3-1.346-3-3V10H22v9c0,1.654-1.346,3-3,3Zm-1.168-8.848c.384,.397,.372,1.031-.025,1.414l-4.74,4.568c-.553,.553-1.307,.866-2.108,.866s-1.555-.312-2.121-.879l-2.252-2.092c-.404-.376-.428-1.009-.052-1.413,.378-.405,1.01-.427,1.413-.052l2.278,2.117c.433,.43,1.063,.402,1.439,.026l4.754-4.582c.398-.383,1.03-.371,1.414,.026Z"
      />
    </svg>
  );
};

export const BookAppointmentNavIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      width="19"
      height="19"
    >
      <path
        fill="currentColor"
        d="M19,2h-1V1c0-.552-.448-1-1-1s-1,.448-1,1v1H8V1c0-.552-.448-1-1-1s-1,.448-1,1v1h-1C2.243,2,0,4.243,0,7v12c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V7c0-2.757-2.243-5-5-5ZM5,4h14c1.654,0,3,1.346,3,3v1H2v-1c0-1.654,1.346-3,3-3Zm14,18H5c-1.654,0-3-1.346-3-3V10H22v9c0,1.654-1.346,3-3,3Zm-3-6c0,.552-.448,1-1,1h-2v2c0,.552-.448,1-1,1s-1-.448-1-1v-2h-2c-.552,0-1-.448-1-1s.448-1,1-1h2v-2c0-.552,.448-1,1-1s1,.448,1,1v2h2c.552,0,1,.448,1,1Z"
      />
    </svg>
  );
};

const CalendarArrowUpIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      width="19"
      height="19"
    >
      <path
        fill="currentColor"
        d="m19,2h-1v-1c0-.552-.447-1-1-1s-1,.448-1,1v1h-8v-1c0-.552-.447-1-1-1s-1,.448-1,1v1h-1C2.243,2,0,4.243,0,7v12c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V7c0-2.757-2.243-5-5-5Zm-14,2h14c1.654,0,3,1.346,3,3v1H2v-1c0-1.654,1.346-3,3-3Zm14,18H5c-1.654,0-3-1.346-3-3v-9h20v9c0,1.654-1.346,3-3,3Zm-3.293-7.52c.391.391.391,1.023,0,1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-1.293-1.293v4.398c0,.553-.447,1-1,1s-1-.447-1-1v-4.398l-1.293,1.293c-.391.391-1.023.391-1.414,0s-.391-1.023,0-1.414l1.613-1.613c1.154-1.154,3.033-1.154,4.188,0l1.613,1.613Z"
      />
    </svg>
  );
};

export default CalendarArrowUpIcon;

export const BookedAppointmentNavIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      width="19"
      height="19"
    >
      <path
        fill="currentColor"
        d="M19,2h-1V1c0-.552-.447-1-1-1s-1,.448-1,1v1H8V1c0-.552-.447-1-1-1s-1,.448-1,1v1h-1C2.243,2,0,4.243,0,7v12c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V7c0-2.757-2.243-5-5-5ZM5,4h14c1.654,0,3,1.346,3,3v1H2v-1c0-1.654,1.346-3,3-3Zm14,18H5c-1.654,0-3-1.346-3-3V10H22v9c0,1.654-1.346,3-3,3Zm-1.168-8.848c.384,.397,.372,1.031-.025,1.414l-4.74,4.568c-.553,.553-1.307,.866-2.108,.866s-1.555-.312-2.121-.879l-2.252-2.092c-.404-.376-.428-1.009-.052-1.413,.378-.405,1.01-.427,1.413-.052l2.278,2.117c.433,.43,1.063,.402,1.439,.026l4.754-4.582c.398-.383,1.03-.371,1.414,.026Z"
      />
    </svg>
  );
};

export const AppointmentRequestsNavIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      width="19"
      height="19"
    >
      <path
        fill="currentColor"
        d="M19,2h-1V1c0-.552-.448-1-1-1s-1,.448-1,1v1H8V1c0-.552-.448-1-1-1s-1,.448-1,1v1h-1C2.243,2,0,4.243,0,7v12c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V7c0-2.757-2.243-5-5-5Zm0,20H5c-1.654,0-3-1.346-3-3V10h6c.552,0,1-.448,1-1s-.448-1-1-1H2v-1c0-1.654,1.346-3,3-3h14c1.654,0,3,1.346,3,3v1h-6c-.552,0-1,.448-1,1s.448,1,1,1h6v9c0,1.654-1.346,3-3,3Zm-6-13v7c0,.552-.448,1-1,1s-1-.448-1-1v-7c0-.552,.448-1,1-1s1,.448,1,1Zm0,10c0,.552-.448,1-1,1s-1-.448-1-1,.448-1,1-1,1,.448,1,1Z"
      />
    </svg>
  );
};

export const DoctorsNavIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      width="17"
      height="17"
    >
      <path
        fill="currentColor"
        d="m14,11v-6c0-1.654-1.346-3-3-3h-6c-1.654,0-3,1.346-3,3v14c0,1.654,1.346,3,3,3h6c.553,0,1,.448,1,1s-.447,1-1,1h-6C2.243,24,0,21.757,0,19V5C0,2.243,2.243,0,5,0h6C13.757,0,16,2.243,16,5v6c0,.552-.447,1-1,1s-1-.448-1-1Zm-8,2h-1c-.553,0-1,.448-1,1s.447,1,1,1h1c.553,0,1-.448,1-1s-.447-1-1-1Zm5,0h-1c-.553,0-1,.448-1,1s.447,1,1,1h1c.553,0,1-.448,1-1s-.447-1-1-1Zm-5,4h-1c-.553,0-1,.448-1,1s.447,1,1,1h1c.553,0,1-.448,1-1s-.447-1-1-1Zm5,0h-1c-.553,0-1,.448-1,1s.447,1,1,1h1c.553,0,1-.448,1-1s-.447-1-1-1Zm-3-7c.553,0,1-.448,1-1v-1h1c.553,0,1-.448,1-1s-.447-1-1-1h-1v-1c0-.552-.447-1-1-1s-1,.448-1,1v1h-1c-.553,0-1,.448-1,1s.447,1,1,1h1v1c0,.552.447,1,1,1Zm11,8c1.381,0,2.5-1.119,2.5-2.5s-1.119-2.5-2.5-2.5-2.5,1.119-2.5,2.5,1.119,2.5,2.5,2.5Zm4.969,4.751c-.561-2.173-2.649-3.75-4.969-3.75s-4.41,1.578-4.969,3.751c-.138.535.185,1.08.72,1.218.084.021.167.032.25.032.445,0,.852-.3.968-.751.329-1.282,1.633-2.249,3.031-2.249s2.701.967,3.031,2.25c.138.535.69.856,1.218.719.535-.138.857-.683.72-1.218Z"
      />
    </svg>
  );
};

export const PatientNavIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="17"
      height="17"
    >
      <g id="_01_align_center" data-name="01 align center">
        <path
          fill="currentColor"
          d="M9,12A6,6,0,1,0,3,6,6.006,6.006,0,0,0,9,12ZM9,2A4,4,0,1,1,5,6,4,4,0,0,1,9,2Z"
        />
        <polygon
          fill="currentColor"
          points="21 10 21 7 19 7 19 10 16 10 16 12 19 12 19 15 21 15 21 12 24 12 24 10 21 10"
        />
        <path
          fill="currentColor"
          d="M13.043,14H4.957A4.963,4.963,0,0,0,0,18.957V24H2V18.957A2.96,2.96,0,0,1,4.957,16h8.086A2.96,2.96,0,0,1,16,18.957V24h2V18.957A4.963,4.963,0,0,0,13.043,14Z"
        />
      </g>
    </svg>
  );
};

export const CardListIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      // fill="#5f6368"
    >
      <path fill="currentColor" d="M560-440h200v-80H560v80Zm0-120h200v-80H560v80ZM200-320h320v-22q0-45-44-71.5T360-440q-72 0-116 26.5T200-342v22Zm160-160q33 0 56.5-23.5T440-560q0-33-23.5-56.5T360-640q-33 0-56.5 23.5T280-560q0 33 23.5 56.5T360-480ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Zm0 0v-480 480Z" />
    </svg>
  );
};

export const AddCardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      // fill="currentColor"
    >
      <g>
        <path
          fill="currentColor"
          d="M9,12A6,6,0,1,0,3,6,6.006,6.006,0,0,0,9,12ZM9,2A4,4,0,1,1,5,6,4,4,0,0,1,9,2Z"
        />
        <polygon
          fill="currentColor"
          points="21 10 21 7 19 7 19 10 16 10 16 12 19 12 19 15 21 15 21 12 24 12 24 10 21 10"
        />
        <path fill="currentColor"
         d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v240H160v240h400v80H160Zm0-480h640v-80H160v80ZM760-80v-120H640v-80h120v-120h80v120h120v80H840v120h-80ZM160-240v-480 480Z" />
      </g>
    </svg>
  );
};

export const DailyReportNavIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Outline"
      viewBox="0 0 24 24"
      width="17"
      height="17"
    >
      <path
        fill="currentColor"
        d="M23,22H3a1,1,0,0,1-1-1V1A1,1,0,0,0,0,1V21a3,3,0,0,0,3,3H23a1,1,0,0,0,0-2Z"
      />
      <path
        fill="currentColor"
        d="M15,20a1,1,0,0,0,1-1V12a1,1,0,0,0-2,0v7A1,1,0,0,0,15,20Z"
      />
      <path
        fill="currentColor"
        d="M7,20a1,1,0,0,0,1-1V12a1,1,0,0,0-2,0v7A1,1,0,0,0,7,20Z"
      />
      <path
        fill="currentColor"
        d="M19,20a1,1,0,0,0,1-1V7a1,1,0,0,0-2,0V19A1,1,0,0,0,19,20Z"
      />
      <path
        fill="currentColor"
        d="M11,20a1,1,0,0,0,1-1V7a1,1,0,0,0-2,0V19A1,1,0,0,0,11,20Z"
      />
    </svg>
  );
};

export const ConsolidatedReportNavIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      width="17"
      height="17"
    >
      <path
        fill="currentColor"
        d="M23,22H5a3,3,0,0,1-3-3V1A1,1,0,0,0,0,1V19a5.006,5.006,0,0,0,5,5H23a1,1,0,0,0,0-2Z"
      />
      <path
        fill="currentColor"
        d="M6,20a1,1,0,0,0,1-1V12a1,1,0,0,0-2,0v7A1,1,0,0,0,6,20Z"
      />
      <path fill="currentColor" d="M10,10v9a1,1,0,0,0,2,0V10a1,1,0,0,0-2,0Z" />
      <path fill="currentColor" d="M15,13v6a1,1,0,0,0,2,0V13a1,1,0,0,0-2,0Z" />
      <path fill="currentColor" d="M20,9V19a1,1,0,0,0,2,0V9a1,1,0,0,0-2,0Z" />
      <path
        fill="currentColor"
        d="M6,9a1,1,0,0,0,.707-.293l3.586-3.586a1.025,1.025,0,0,1,1.414,0l2.172,2.172a3,3,0,0,0,4.242,0l5.586-5.586A1,1,0,0,0,22.293.293L16.707,5.878a1,1,0,0,1-1.414,0L13.121,3.707a3,3,0,0,0-4.242,0L5.293,7.293A1,1,0,0,0,6,9Z"
      />
    </svg>
  );
};

const HealthProfile = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.4907 63.3708C33.2177 63.3708 32.9649 63.3243 32.7323 63.2313C32.4997 63.1382 32.267 62.9753 32.0344 62.7427L25.0552 55.7635H12.5625C11.4458 55.7635 10.4688 55.3448 9.63125 54.5073C8.79375 53.6698 8.375 52.6927 8.375 51.576V9.70104C8.375 8.54948 8.79375 7.56367 9.63125 6.74362C10.4688 5.92357 11.4458 5.51354 12.5625 5.51354H54.4375C55.5542 5.51354 56.5312 5.92357 57.3688 6.74362C58.2062 7.56367 58.625 8.54948 58.625 9.70104V51.576C58.625 52.6927 58.2062 53.6698 57.3688 54.5073C56.5312 55.3448 55.5542 55.7635 54.4375 55.7635H41.9448L34.9656 62.7427C34.733 62.9753 34.4973 63.1382 34.2584 63.2313C34.0196 63.3243 33.7637 63.3708 33.4907 63.3708ZM12.5625 48.924C15.3542 46.3649 18.5156 44.2828 22.0469 42.6776C25.5782 41.0724 29.3935 40.2698 33.4927 40.2698C37.592 40.2698 41.4097 41.0724 44.9458 42.6776C48.4819 44.2828 51.6458 46.3649 54.4375 48.924V9.70104H12.5625V48.924ZM33.6396 34.7563C36.3382 34.7563 38.6181 33.8257 40.4792 31.9646C42.3403 30.1035 43.2708 27.8236 43.2708 25.125C43.2708 22.4264 42.3403 20.1465 40.4792 18.2854C38.6181 16.4243 36.3382 15.4938 33.6396 15.4938C30.941 15.4938 28.6611 16.4243 26.8 18.2854C24.9389 20.1465 24.0083 22.4264 24.0083 25.125C24.0083 27.8236 24.9389 30.1035 26.8 31.9646C28.6611 33.8257 30.941 34.7563 33.6396 34.7563ZM33.6396 30.5688C32.1274 30.5688 30.8421 30.0395 29.7836 28.981C28.7251 27.9225 28.1958 26.6372 28.1958 25.125C28.1958 23.6128 28.7251 22.3275 29.7836 21.269C30.8421 20.2105 32.1274 19.6813 33.6396 19.6813C35.1517 19.6813 36.4371 20.2105 37.4956 21.269C38.5541 22.3275 39.0833 23.6128 39.0833 25.125C39.0833 26.6372 38.5541 27.9225 37.4956 28.981C36.4371 30.0395 35.1517 30.5688 33.6396 30.5688ZM33.5 57.9969L39.9208 51.576H50.599V50.9479C48.0865 48.8076 45.3959 47.1908 42.5274 46.0974C39.6589 45.004 36.6497 44.4573 33.5 44.4573C30.3826 44.4573 27.3816 45.004 24.4969 46.0974C21.6122 47.1908 18.9135 48.8076 16.401 50.9479V51.576H27.0792L33.5 57.9969Z"
        fill="currentColor"
      />
    </svg>
  );
};

const HealthFiles = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.1458 43.75L38.9062 40.9375L34.0625 36.0937L31.25 38.8542C30.5556 39.5486 30.217 40.3646 30.2344 41.3021C30.2517 42.2396 30.5903 43.0555 31.25 43.75C31.9444 44.4097 32.7604 44.7483 33.6979 44.7656C34.6354 44.783 35.4514 44.4444 36.1458 43.75ZM41.0417 38.8021L43.8542 36.0417C44.5486 35.3472 44.8872 34.5312 44.8698 33.5937C44.8524 32.6562 44.4965 31.8403 43.8021 31.1458C43.1076 30.4514 42.3042 30.1042 41.3917 30.1042C40.4792 30.1042 39.6681 30.4514 38.9583 31.1458L36.1979 33.9583L41.0417 38.8021ZM38.3333 45.9375C37.0486 47.2222 35.5035 47.8646 33.6979 47.8646C31.8924 47.8646 30.3472 47.2222 29.0625 45.9375C27.7778 44.6528 27.1354 43.1076 27.1354 41.3021C27.1354 39.4965 27.7778 37.9514 29.0625 36.6667L36.7708 28.9583C38.0556 27.6736 39.6007 27.0312 41.4062 27.0312C43.2118 27.0312 44.7569 27.6736 46.0417 28.9583C47.3264 30.243 47.9688 31.7882 47.9688 33.5937C47.9688 35.3993 47.3264 36.9444 46.0417 38.2292L38.3333 45.9375ZM9.375 43.75C8.51562 43.75 7.77995 43.444 7.16797 42.832C6.55599 42.22 6.25 41.4844 6.25 40.625V9.37499C6.25 8.51562 6.55599 7.77994 7.16797 7.16796C7.77995 6.55598 8.51562 6.24999 9.375 6.24999H20.0521C20.2257 5.03472 20.7812 4.03645 21.7188 3.2552C22.6562 2.47395 23.75 2.08333 25 2.08333C26.25 2.08333 27.3438 2.47395 28.2812 3.2552C29.2188 4.03645 29.7743 5.03472 29.9479 6.24999H40.625C41.4844 6.24999 42.2201 6.55598 42.832 7.16796C43.444 7.77994 43.75 8.51562 43.75 9.37499V24.1667C43.2292 24.0278 42.7083 23.941 42.1875 23.9062C41.6667 23.8715 41.1458 23.8889 40.625 23.9583V9.37499H9.375V40.625H24.0104C23.9757 41.1458 23.9844 41.6667 24.0365 42.1875C24.0885 42.7083 24.184 43.2292 24.3229 43.75H9.375ZM25 8.48958C25.4861 8.48958 25.9115 8.30729 26.276 7.9427C26.6406 7.57812 26.8229 7.15277 26.8229 6.66666C26.8229 6.18055 26.6406 5.7552 26.276 5.39062C25.9115 5.02604 25.4861 4.84374 25 4.84374C24.5139 4.84374 24.0885 5.02604 23.724 5.39062C23.3594 5.7552 23.1771 6.18055 23.1771 6.66666C23.1771 7.15277 23.3594 7.57812 23.724 7.9427C24.0885 8.30729 24.5139 8.48958 25 8.48958ZM14.5833 17.7083V14.5833H35.4167V17.7083H14.5833ZM14.5833 26.5625V23.4375H35.4167V25.9896C35.3125 26.059 35.1997 26.1458 35.0781 26.25C34.9566 26.3542 34.8438 26.4583 34.7396 26.5625H14.5833ZM14.5833 35.4167V32.2917H29.0104L26.8229 34.4792C26.6493 34.6528 26.5017 34.809 26.3802 34.9479C26.2587 35.0868 26.1285 35.243 25.9896 35.4167H14.5833Z"
        fill="currentColor"
      />
    </svg>
  );
};

const MyDoctors = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2917 46.3198L18.826 41.2958C15.624 38.3514 12.9648 35.8302 10.8484 33.7323C8.73211 31.6344 7.02986 29.7389 5.74166 28.0458C4.45347 26.3528 3.54253 24.7609 3.00885 23.2703C2.47517 21.7797 2.20833 20.1878 2.20833 18.4948C2.20833 15.1823 3.3217 12.3759 5.54843 10.0755C7.77517 7.77517 10.5264 6.625 13.8021 6.625C15.9 6.625 17.8415 7.11267 19.6266 8.08802C21.4116 9.06337 22.9667 10.4896 24.2917 12.3667C25.8375 10.3792 27.4753 8.92535 29.2052 8.00521C30.9351 7.08507 32.7937 6.625 34.7812 6.625C37.7469 6.625 40.2366 7.63715 42.2503 9.66146C44.264 11.6858 45.4917 14.1333 45.9333 17.0042H42.676C42.3448 14.9799 41.4891 13.296 40.1088 11.9526C38.7286 10.6092 36.9528 9.9375 34.7812 9.9375C32.9042 9.9375 31.1559 10.508 29.5365 11.649C27.917 12.7899 26.6104 14.4094 25.6167 16.5073H22.9115C21.9545 14.4462 20.6663 12.8359 19.0469 11.6766C17.4274 10.5172 15.6792 9.9375 13.8021 9.9375C11.3729 9.9375 9.38541 10.7564 7.83958 12.3943C6.29375 14.0321 5.52083 16.0656 5.52083 18.4948C5.52083 19.9302 5.80607 21.3288 6.37656 22.6906C6.94704 24.0524 7.93873 25.5995 9.35162 27.3318C10.7645 29.0642 12.6876 31.0885 15.1209 33.4047C17.5542 35.721 20.6111 38.5722 24.2917 41.9583C25.4694 40.891 26.5828 39.8972 27.6318 38.9771C28.6807 38.0569 29.7205 37.1552 30.751 36.2719L31.1172 36.6293L31.9104 37.4036L32.7036 38.178L33.0698 38.5354C32.076 39.4188 31.0455 40.3205 29.9781 41.2406C28.9108 42.1608 27.7698 43.1729 26.5552 44.2771L24.2917 46.3198ZM40.3021 37.5417V30.3646H33.125V27.0521H40.3021V19.875H43.6146V27.0521H50.7917V30.3646H43.6146V37.5417H40.3021Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Faq = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.875 37.5H8.4375C7.6875 37.5 7.03125 37.2109 6.46875 36.6328C5.90625 36.0547 5.625 35.4062 5.625 34.6875V6.5625C5.625 5.8125 5.90625 5.15625 6.46875 4.59375C7.03125 4.03125 7.6875 3.75 8.4375 3.75H36.5625C37.2812 3.75 37.9297 4.03125 38.5078 4.59375C39.0859 5.15625 39.375 5.8125 39.375 6.5625V34.6875C39.375 35.4062 39.0859 36.0547 38.5078 36.6328C37.9297 37.2109 37.2812 37.5 36.5625 37.5H28.125L23.4844 42.1406C23.2031 42.4219 22.875 42.5625 22.5 42.5625C22.125 42.5625 21.7969 42.4219 21.5156 42.1406L16.875 37.5ZM8.4375 34.6875H18L22.5 39.1875L27 34.6875H36.5625V6.5625H8.4375V34.6875ZM22.7826 31.6406C23.2817 31.6406 23.7031 31.4683 24.0469 31.1237C24.3906 30.7791 24.5625 30.3572 24.5625 29.8581C24.5625 29.3589 24.3902 28.9375 24.0456 28.5937C23.7009 28.25 23.2791 28.0781 22.7799 28.0781C22.2808 28.0781 21.8594 28.2504 21.5156 28.5951C21.1719 28.9397 21 29.3616 21 29.8607C21 30.3598 21.1723 30.7812 21.5169 31.125C21.8616 31.4687 22.2834 31.6406 22.7826 31.6406ZM26.1094 15.075C26.1094 15.7125 25.9375 16.3203 25.5938 16.8984C25.25 17.4766 24.6719 18.1562 23.8594 18.9375C23.2969 19.4687 22.8516 19.9375 22.5234 20.3437C22.1953 20.75 21.9375 21.1562 21.75 21.5625C21.625 21.8125 21.5312 22.0859 21.4688 22.3828C21.4062 22.6797 21.3438 23 21.2812 23.3437C21.2188 23.6875 21.3203 24 21.5859 24.2812C21.8516 24.5625 22.1763 24.7031 22.5603 24.7031C22.8962 24.7031 23.1962 24.5807 23.4601 24.3357C23.7241 24.0908 23.904 23.7601 24 23.3437C24.125 22.8125 24.3359 22.3203 24.6328 21.8672C24.9297 21.4141 25.3906 20.875 26.0156 20.25C27.0469 19.2187 27.7656 18.3047 28.1719 17.5078C28.5781 16.7109 28.7812 15.8703 28.7812 14.9859C28.7812 13.339 28.2529 12.0312 27.1961 11.0625C26.1394 10.0937 24.699 9.60937 22.875 9.60937C21.5312 9.60937 20.3438 9.88975 19.3125 10.4505C18.2812 11.0113 17.4531 11.7934 16.8281 12.7969C16.6406 13.1094 16.6172 13.4219 16.7578 13.7344C16.8984 14.0469 17.147 14.2812 17.5035 14.4375C17.8345 14.5937 18.1641 14.6172 18.4922 14.5078C18.8203 14.3984 19.1094 14.2031 19.3594 13.9219C19.7969 13.3906 20.3125 12.9844 20.9062 12.7031C21.5 12.4219 22.1562 12.2812 22.875 12.2812C23.875 12.2812 24.6641 12.5312 25.2422 13.0312C25.8203 13.5312 26.1094 14.2125 26.1094 15.075Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Privacy = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.008 30.9833C22.3999 30.9833 22.7257 30.8516 22.9854 30.588C23.2451 30.3245 23.375 29.9979 23.375 29.6083V20.5792C23.375 20.1896 23.2425 19.863 22.9774 19.5995C22.7123 19.3359 22.3838 19.2042 21.992 19.2042C21.6001 19.2042 21.2743 19.3359 21.0146 19.5995C20.7549 19.863 20.625 20.1896 20.625 20.5792V29.6083C20.625 29.9979 20.7575 30.3245 21.0226 30.588C21.2877 30.8516 21.6162 30.9833 22.008 30.9833ZM22 16.1792C22.4415 16.1792 22.8116 16.0298 23.1103 15.7311C23.409 15.4325 23.5583 15.0624 23.5583 14.6208C23.5583 14.1793 23.409 13.8092 23.1103 13.5105C22.8116 13.2118 22.4415 13.0625 22 13.0625C21.5585 13.0625 21.1884 13.2118 20.8897 13.5105C20.591 13.8092 20.4417 14.1793 20.4417 14.6208C20.4417 15.0624 20.591 15.4325 20.8897 15.7311C21.1884 16.0298 21.5585 16.1792 22 16.1792ZM22 40.15C21.8375 40.15 21.6865 40.1347 21.5472 40.1042C21.4078 40.0736 21.2685 40.0278 21.1292 39.9667C16.882 38.5306 13.5208 35.9563 11.0458 32.2438C8.57084 28.5313 7.33334 24.4581 7.33334 20.0243V11.0458C7.33334 10.4574 7.49949 9.92787 7.83178 9.45716C8.16407 8.98642 8.59376 8.64515 9.12084 8.43334L21.0375 3.9875C21.3736 3.86528 21.6945 3.80417 22 3.80417C22.3056 3.80417 22.6264 3.86528 22.9625 3.9875L34.8792 8.43334C35.4063 8.64515 35.8359 8.98642 36.1682 9.45716C36.5005 9.92787 36.6667 10.4574 36.6667 11.0458V20.0243C36.6667 24.4581 35.4292 28.5313 32.9542 32.2438C30.4792 35.9563 27.1181 38.5306 22.8708 39.9667C22.7315 40.0278 22.5922 40.0736 22.4528 40.1042C22.3135 40.1347 22.1626 40.15 22 40.15ZM22 37.4458C25.5139 36.2847 28.3785 34.0924 30.5938 30.8688C32.809 27.6451 33.9167 24.0319 33.9167 20.0292V11.0458L22 6.55417L10.0833 11.0458V20.0292C10.0833 24.0319 11.191 27.6451 13.4063 30.8688C15.6215 34.0924 18.4861 36.2847 22 37.4458Z"
        fill="currentColor"
      />
    </svg>
  );
};

const VideoCallIcon = () => {
  return (
    <svg
      width="46"
      height="36"
      viewBox="0 0 46 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6223 27C19.1033 27 19.5031 26.8383 19.8219 26.5148C20.1406 26.1914 20.3 25.7906 20.3 25.3125V19.575H26.0375C26.5156 19.575 26.9164 19.4123 27.2398 19.087C27.5633 18.7617 27.725 18.3586 27.725 17.8777C27.725 17.3967 27.5633 16.9969 27.2398 16.6781C26.9164 16.3594 26.5156 16.2 26.0375 16.2H20.3V10.4625C20.3 9.98438 20.1373 9.58359 19.812 9.26016C19.4867 8.93672 19.0836 8.775 18.6027 8.775C18.1217 8.775 17.7219 8.93672 17.4031 9.26016C17.0844 9.58359 16.925 9.98438 16.925 10.4625V16.2H11.1875C10.7094 16.2 10.3086 16.3627 9.98516 16.688C9.66172 17.0133 9.5 17.4164 9.5 17.8973C9.5 18.3783 9.66172 18.7781 9.98516 19.0969C10.3086 19.4156 10.7094 19.575 11.1875 19.575H16.925V25.3125C16.925 25.7906 17.0877 26.1914 17.413 26.5148C17.7383 26.8383 18.1414 27 18.6223 27ZM3.875 36C2.975 36 2.1875 35.6625 1.5125 34.9875C0.8375 34.3125 0.5 33.525 0.5 32.625V3.375C0.5 2.475 0.8375 1.6875 1.5125 1.0125C2.1875 0.3375 2.975 0 3.875 0H33.125C34.025 0 34.8125 0.3375 35.4875 1.0125C36.1625 1.6875 36.5 2.475 36.5 3.375V15.4688L44.0375 7.93125C44.3375 7.63125 44.6562 7.55625 44.9937 7.70625C45.3312 7.85625 45.5 8.11875 45.5 8.49375V27.5062C45.5 27.8812 45.3312 28.1437 44.9937 28.2937C44.6562 28.4437 44.3375 28.3687 44.0375 28.0687L36.5 20.5312V32.625C36.5 33.525 36.1625 34.3125 35.4875 34.9875C34.8125 35.6625 34.025 36 33.125 36H3.875ZM3.875 32.625H33.125V3.375H3.875V32.625Z"
        fill="black"
      />
    </svg>
  );
};

const Prescription = () => {
  return (
    <svg
      width="42"
      height="46"
      viewBox="0 0 42 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.1458 41.75L32.9062 38.9375L28.0625 34.0937L25.25 36.8542C24.5556 37.5486 24.217 38.3646 24.2344 39.3021C24.2517 40.2396 24.5903 41.0555 25.25 41.75C25.9444 42.4097 26.7604 42.7483 27.6979 42.7656C28.6354 42.783 29.4514 42.4444 30.1458 41.75ZM35.0417 36.8021L37.8542 34.0417C38.5486 33.3472 38.8872 32.5312 38.8698 31.5937C38.8524 30.6562 38.4965 29.8403 37.8021 29.1458C37.1076 28.4514 36.3042 28.1042 35.3917 28.1042C34.4792 28.1042 33.6681 28.4514 32.9583 29.1458L30.1979 31.9583L35.0417 36.8021ZM32.3333 43.9375C31.0486 45.2222 29.5035 45.8646 27.6979 45.8646C25.8924 45.8646 24.3472 45.2222 23.0625 43.9375C21.7778 42.6528 21.1354 41.1076 21.1354 39.3021C21.1354 37.4965 21.7778 35.9514 23.0625 34.6667L30.7708 26.9583C32.0556 25.6736 33.6007 25.0312 35.4062 25.0312C37.2118 25.0312 38.7569 25.6736 40.0417 26.9583C41.3264 28.243 41.9688 29.7882 41.9688 31.5937C41.9688 33.3993 41.3264 34.9444 40.0417 36.2292L32.3333 43.9375ZM3.375 41.75C2.51562 41.75 1.77995 41.444 1.16797 40.832C0.55599 40.22 0.25 39.4844 0.25 38.625V7.37499C0.25 6.51562 0.55599 5.77994 1.16797 5.16796C1.77995 4.55598 2.51562 4.24999 3.375 4.24999H14.0521C14.2257 3.03472 14.7812 2.03645 15.7188 1.2552C16.6562 0.473953 17.75 0.0833282 19 0.0833282C20.25 0.0833282 21.3438 0.473953 22.2812 1.2552C23.2188 2.03645 23.7743 3.03472 23.9479 4.24999H34.625C35.4844 4.24999 36.2201 4.55598 36.832 5.16796C37.444 5.77994 37.75 6.51562 37.75 7.37499V22.1667C37.2292 22.0278 36.7083 21.941 36.1875 21.9062C35.6667 21.8715 35.1458 21.8889 34.625 21.9583V7.37499H3.375V38.625H18.0104C17.9757 39.1458 17.9844 39.6667 18.0365 40.1875C18.0885 40.7083 18.184 41.2292 18.3229 41.75H3.375ZM19 6.48958C19.4861 6.48958 19.9115 6.30729 20.276 5.9427C20.6406 5.57812 20.8229 5.15277 20.8229 4.66666C20.8229 4.18055 20.6406 3.7552 20.276 3.39062C19.9115 3.02604 19.4861 2.84374 19 2.84374C18.5139 2.84374 18.0885 3.02604 17.724 3.39062C17.3594 3.7552 17.1771 4.18055 17.1771 4.66666C17.1771 5.15277 17.3594 5.57812 17.724 5.9427C18.0885 6.30729 18.5139 6.48958 19 6.48958ZM8.58333 15.7083V12.5833H29.4167V15.7083H8.58333ZM8.58333 24.5625V21.4375H29.4167V23.9896C29.3125 24.059 29.1997 24.1458 29.0781 24.25C28.9566 24.3542 28.8438 24.4583 28.7396 24.5625H8.58333ZM8.58333 33.4167V30.2917H23.0104L20.8229 32.4792C20.6493 32.6528 20.5017 32.809 20.3802 32.9479C20.2587 33.0868 20.1285 33.243 19.9896 33.4167H8.58333Z"
        fill="black"
      />
    </svg>
  );
};

const Notification = () => {
  return (
    <svg
      width="44"
      height="54"
      viewBox="0 0 44 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66666 45.6667C2.09999 45.6667 1.62499 45.4739 1.24166 45.0883C0.858323 44.7027 0.666656 44.225 0.666656 43.655C0.666656 43.085 0.858323 42.6111 1.24166 42.2333C1.62499 41.8556 2.09999 41.6667 2.66666 41.6667H5.99999V21.4C5.99999 17.6667 7.09999 14.3222 9.29999 11.3667C11.5 8.41111 14.4 6.55556 18 5.8V4.33334C18 3.22222 18.3889 2.27778 19.1667 1.5C19.9444 0.722225 20.8889 0.333336 22 0.333336C23.1111 0.333336 24.0555 0.722225 24.8333 1.5C25.6111 2.27778 26 3.22222 26 4.33334V5.8C29.6 6.55556 32.5 8.41111 34.7 11.3667C36.9 14.3222 38 17.6667 38 21.4V41.6667H41.3333C41.9 41.6667 42.375 41.8594 42.7583 42.245C43.1417 42.6306 43.3333 43.1084 43.3333 43.6783C43.3333 44.2483 43.1417 44.7222 42.7583 45.1C42.375 45.4778 41.9 45.6667 41.3333 45.6667H2.66666ZM22 53.6667C20.5333 53.6667 19.2778 53.1444 18.2333 52.1C17.1889 51.0556 16.6667 49.8 16.6667 48.3333H27.3333C27.3333 49.8 26.8111 51.0556 25.7667 52.1C24.7222 53.1444 23.4667 53.6667 22 53.6667ZM9.99999 41.6667H34V21.4C34 18.0667 32.8333 15.2333 30.5 12.9C28.1667 10.5667 25.3333 9.4 22 9.4C18.6667 9.4 15.8333 10.5667 13.5 12.9C11.1667 15.2333 9.99999 18.0667 9.99999 21.4V41.6667ZM22.0117 30.6C22.5817 30.6 23.0555 30.4083 23.4333 30.025C23.8111 29.6417 24 29.1667 24 28.6V18.3333C24 17.7667 23.8072 17.2917 23.4217 16.9083C23.0361 16.525 22.5583 16.3333 21.9883 16.3333C21.4183 16.3333 20.9444 16.525 20.5667 16.9083C20.1889 17.2917 20 17.7667 20 18.3333V28.6C20 29.1667 20.1928 29.6417 20.5783 30.025C20.9639 30.4083 21.4417 30.6 22.0117 30.6ZM21.9988 37.6667C22.6218 37.6667 23.1444 37.456 23.5667 37.0345C23.9889 36.6131 24.2 36.0908 24.2 35.4679C24.2 34.8448 23.9893 34.3222 23.5679 33.9C23.1464 33.4778 22.6242 33.2667 22.0012 33.2667C21.3782 33.2667 20.8555 33.4774 20.4333 33.8988C20.0111 34.3203 19.8 34.8425 19.8 35.4655C19.8 36.0885 20.0107 36.6111 20.4321 37.0333C20.8536 37.4556 21.3758 37.6667 21.9988 37.6667Z"
        fill="black"
      />
    </svg>
  );
};

export const NavIcons = {
  icon_dashboard,
  BookAppointmentNavIcon,
  BookedAppointmentNavIcon,
  AppointmentRequestsNavIcon,
  HealthProfile,
  HealthFiles,
  MyDoctors,
  Faq,
  Privacy,
  VideoCallIcon,
  Prescription,
  Notification,
};
